// @flow
import {resources} from 'i18n'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

export default i18next
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: 'es',
    resources
  })



// WEBPACK FOOTER //
// ./src/i18n.js